module.exports = __webpack_public_path__ + "espa.bea17821.jpg";